export const hasName = (person: {
  firstName?: string | null;
  lastName?: string | null;
}): boolean => !!person.firstName || !!person.lastName;

export const displayName = (person: {
  firstName?: string | null;
  lastName?: string | null;
}): string => {
  return person.firstName || person.lastName || '';
};

export const displayFullName = (person: {
  firstName?: string | null;
  lastName?: string | null;
}): string => {
  if (!!person.firstName && !!person.lastName) {
    return `${person.firstName} ${person.lastName}`;
  }
  return person.firstName || person.lastName || '';
};

export const displayNameInMessage = (person: {
  firstName?: string | null;
  lastName?: string | null;
}): string => {
  const lastNameInitial = person.lastName?.[0]?.toUpperCase() ?? '';
  const lastPart = lastNameInitial ? ` ${lastNameInitial}.` : '';
  return `${person.firstName ?? ''}${lastPart}`;
};

export const groupName = (
  persons: { firstName?: string | null; lastName?: string | null }[],
): string => {
  const names = persons.map((member) => displayName(member));
  if (names.length <= 1) {
    return names[0] ?? '';
  }
  const [first, ...rest] = names;
  return rest.reduce((result, name, index) => {
    const separator = index === rest.length - 1 ? ', & ' : ', ';
    return `${result}${separator}${name}`;
  }, first);
};

export const nameInitials = (person: {
  firstName?: string | null;
  lastName?: string | null;
}): string => {
  const F = person.firstName?.[0]?.toUpperCase() ?? '';
  const L = person.lastName?.[0]?.toUpperCase() ?? '';
  return F + L;
};
